import React, { FunctionComponent } from 'react';
// import { DragDropContext } from 'react-beautiful-dnd';
import { IWidgetWrapperSingleColumnParams } from './types';

export const WidgetWrapperSingleColumn: FunctionComponent<IWidgetWrapperSingleColumnParams> = ({
  name,
  actionElement,
  filterElement,
  headerElements,
  children,
  size,
}) => {
  let colClass;
  switch (size) {
    case '1/2':
      colClass = 'col-6';
      break;
    case '2/3':
      colClass = 'col-8';
      break;
    case 'full':
      colClass = 'col-12';
      break;
    default:
      colClass = 'col-4';
  }

  return (
    <div className={`${colClass} mb-3 home-page-widget-column`} style={{ minHeight: 450 }}>
      <div className="flex flex-column panel home-page-widget-panel">
        <div className="panel-header">
          <h2 className="bold flex">{name}</h2>
          <div className="ml-auto flex align-center">
            {headerElements?.map((el, i) => (
              <React.Fragment key={i}>{el}</React.Fragment>
            ))}
            {actionElement}
          </div>
        </div>
        <div className="panel-body" style={{ flexGrow: 1 }}>
          <div className="border-radius-1 lightGray-bg" style={{ height: '100%' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
